import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/frequently-asked-questions-screen';
import faqs from './FrequentlyAskedQuestions.json';

function FrequentlyAskedQuestions() {
  return <Screen faqs={faqs} />;
}

export default FrequentlyAskedQuestions;
